import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_119: DocMigration = {
  maxSchemaVersion: "0.0.119",
  description: "Facade horizontal datums",
  apply(json: any) {
    for (const facadeId in json.facades) {
      const facade = json.facades[facadeId];
      const { datumTable, spanStrata } = facade;

      // add the VERTICAL type to exsiting datums
      for (const datumId in datumTable) {
        const datum = datumTable[datumId];
        datumTable[datumId] = {
          ...datum,
          type: "VERTICAL",
        };
      }

      // add the default HORIZONTAL datums
      datumTable["WALL_START"] = {
        type: "HORIZONTAL",
        name: "WALL_START",
        justification: "START_TO_END",
        offset: 0,
        offsetNormalized: false,
      };

      datumTable["WALL_END"] = {
        type: "HORIZONTAL",
        name: "WALL_END",
        justification: "END_TO_START",
        offset: 0,
        offsetNormalized: false,
      };

      // add the start and end datums to the existing spans
      if (spanStrata) {
        // array of type any to avoid imporing types in migration files
        const newSpanStrata: any[] = [];

        for (const span of spanStrata) {
          newSpanStrata.push({
            ...span,
            startDatum: "WALL_START",
            endDatum: "WALL_END",
          });
        }

        facade.spanStrata = newSpanStrata;
      }
    }

    return json;
  },
};

export default migration_0_0_119;
